var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-account-layout"},[_c('my-account-navigation',{staticClass:"gray-border-circle"}),_vm._v(" "),_c('router-view',{staticClass:"my-account-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }